import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { DepositHistoryTemplate } from 'components/Templates'

const DepositHistory: FC = () => {
  return (
    <Layout headline={'入金履歴明細一覧'} iconPath={'/icon/white/revenue.svg'} title={'入金履歴明細一覧'}>
      <DepositHistoryTemplate />
    </Layout>
  )
}

export default DepositHistory
